import {useSharedValueEffects} from '@epic-core/hooks';
import {ReduxEffects} from './shared/redux.effect';

export const AppEffects = () => {
    useSharedValueEffects([ReduxEffects]);

    return null;
};
